import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { useToasts } from '../../hooks';
import { useFetchSite } from '../../utils/api/site';
import { CurrentUserProvider } from '../../providers/CurrentUserProvider';
import { withContextProvider } from '../../hoc';
import { DialogsProvider, ToastProvider } from '../../providers';
import SiteDetailPageTabsWrapper from '../../componentsV2/Site/SiteDetailsPageTabs/SiteDetailPageTabsWrapper';
import SiteDetailsPage from '../../componentsV2/Site/SiteDetailsPage/SiteDetailsPage';
import HeaderWithBreadcrumbs from '../../componentsV2/Headers/HeaderWithBreadcrumbs';

const SiteShow = ({
  siteId,
  organizationId,
  organizationTags,
  values,
  modelFormItems,
  isManager,
  contactModelFormItems,
  currentUserId,
  currentUserRole,
}) => {
  // Hook Toast
  const { showToast } = useToasts();
  const [siteData, setSiteData] = useState({});
  const fetchSite = useFetchSite({
    siteId, organizationId, setSiteData, showToast,
  });

  const breadcrumbLinks = [
    { href: '/sites', name: 'Sites' },
    { name: siteData.name },
  ];

  useEffect(() => {
    fetchSite();
  }, [fetchSite]);
  if (!siteData.name) return null; // stop rendering if siteData is empty
  return (
    <CurrentUserProvider values={{ isManager, contactModelFormItems }}>
      <DialogsProvider>
        <div className="ml-2.75">
          <header>
            <HeaderWithBreadcrumbs links={breadcrumbLinks} className="pb-4" name="site" label="Sites" size="h-10" shouldNotDisplayHeader />
          </header>
        </div>
        <div className="ml-6.25 mr-10.5">
          <div className="flex flex-col font-sans w-85">
            <div className="min-h-125 md:min-h-210">
              <SiteDetailsPage siteData={siteData} setSiteData={setSiteData} organizationTags={organizationTags} values={values} modelFormItems={modelFormItems} isManager={isManager} />
            </div>
            <div className="border-t border-vamos-blue-gray self-stretch" />
            <div className="mb-24 w-full min-h-125 md:min-h-200">
              <SiteDetailPageTabsWrapper siteData={siteData} setSiteData={setSiteData} currentUserRole={currentUserRole} currentUserId={currentUserId} />
            </div>
          </div>
        </div>
      </DialogsProvider>
    </CurrentUserProvider>
  );
};

SiteShow.propTypes = {
  siteId: PropTypes.number.isRequired,
  organizationId: PropTypes.number.isRequired,
  organizationTags: PropTypes.array.isRequired,
  values: PropTypes.object.isRequired,
  modelFormItems: PropTypes.array.isRequired,
  isManager: PropTypes.bool.isRequired,
  contactModelFormItems: PropTypes.array.isRequired,
  currentUserId: PropTypes.number.isRequired,
  currentUserRole: PropTypes.string.isRequired,
};
export default withContextProvider(ToastProvider)(SiteShow);
